export default {
    bindings: {
        amount: '<',
        round: '<',
        decorate: '@',
        currencyCode: '<'
    },
    controller: 'moneyController',
    template: require('../views/money.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/components/money.component.js